import { Injectable } from '@angular/core';
import { BrowselistsPrecondition } from '../browselists-precondition';
import { util } from '../../util';
import { IObject } from '../../../../type_definitions/datatypes';

@Injectable()
export class NewRolePreconditionService extends BrowselistsPrecondition {
  public execute(queryFilters: IObject): string | void {
    if (util.isNullOrUndefinedOrEmpty(queryFilters['Webshop_id'])) {
      return 'Please select a Webshop before adding a new role';
    }
  }
}